var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestCancellationDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EDEFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0914 17.8483L20.5005 19.4393L18.9095 17.8483L17.8488 18.909L19.4398 20.5L17.8488 22.091L18.9095 23.1517L20.5005 21.5607L22.0914 23.1517L23.1521 22.091L21.5611 20.5L23.1521 18.909L22.0914 17.8483Z",
    fill: "#96A0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26.5C17.2 26.5 14.5 23.8 14.5 20.5C14.5 17.2 17.2 14.5 20.5 14.5C23.8 14.5 26.5 17.2 26.5 20.5C26.5 23.8 23.8 26.5 20.5 26.5ZM20.5 16C18.025 16 16 18.025 16 20.5C16 22.975 18.025 25 20.5 25C22.975 25 25 22.975 25 20.5C25 18.025 22.975 16 20.5 16Z",
    fill: "#96A0BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.5C25 7.675 24.325 7 23.5 7H20.5V5.5H19V7H13V5.5H11.5V7H8.5C7.675 7 7 7.675 7 8.5V23.5C7 24.325 7.675 25 8.5 25H13V23.5H8.5V8.5H11.5V10H13V8.5H19V10H20.5V8.5H23.5V13H25V8.5Z",
    fill: "#96A0BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCancellationDisabled);
export default __webpack_public_path__ + "static/media/requestCancellationDisabled.790e02494cc552aacd953afd959ede05.svg";
export { ForwardRef as ReactComponent };